const { start } = require("activestorage");

// Refactor initialization into separate functions
function initializeDropdowns() {
  document.querySelectorAll('.dropdown-trigger').forEach(element => {
    if (!element.dataset.dropdownInitialized) {
      M.Dropdown.init(element, {
        constrainWidth: false,
        coverTrigger: false
      });
      element.dataset.dropdownInitialized = "true";
    }
  });
}

function updateTextFields() {
  M.updateTextFields();
}

function initializeSelects() {
  if (!window.M) return;
  
  document.querySelectorAll('select:not([data-initialized]):not(.select2):not([data-rui])').forEach(element => {
    try {
      // Mark the element as initialized
      element.setAttribute('data-initialized', 'true');

      // Destroy old instances if they exist
      let instance = M.FormSelect.getInstance(element);
      if (instance) {
        instance.destroy();
      }

      // Initialize with safe options
      M.FormSelect.init(element, {
        dropdownOptions: {
          container: document.body
        }
      });
    } catch (error) {
      console.error('Error initializing select:', error, element);
    }
  });
}


function initializeCollapsibles() {
  document.querySelectorAll('.collapsible').forEach(element => {
    if (!element.classList.contains('reInit')) {
      M.Collapsible.init(element, { accordion: false });
    }
  });
}

function initializeTabs() {
  document.querySelectorAll('.tabs').forEach(element => {
    M.Tabs.init(element);
  });
}

function initializeMobileFormat() {
  document.querySelectorAll('.phone-format').forEach(input => {
    input.addEventListener('input', function () {
      let numbers = this.value.replace(/\D/g, '');
      let formatted = '';
      const char = {4: ' ', 7: ' '};
      for (let i = 0; i < numbers.length; i++) {
        formatted += (char[i] || '') + numbers[i];
      }
      this.value = formatted;
    });
  });
}

// Wait for Materialize to be loaded before initializing
function initializeWhenReady() {
  // Layouts without the Materialize loader (e.g. showcase) never define this
  if (!window.materializeLoaded) return;
  window.materializeLoaded.then((M) => {
    if (!M) return; // Skip if Materialize isn't loaded (Tailwind mode)
    
    initializeDropdowns();
    updateTextFields();
    initializeSelects();
    initializeCollapsibles();
    initializeTabs();
    initializeMobileFormat();
  }).catch(err => {
    console.error('Error initializing Materialize components:', err);
  });
}

// Initialize on both DOMContentLoaded and turbo:load
document.addEventListener('DOMContentLoaded', initializeWhenReady);
document.addEventListener('turbo:load', initializeWhenReady);
document.addEventListener('turbo:frame-load', () => {
  initializeDropdowns();
  initializeSelects();
  updateTextFields();
});

// Handle nested form additions (jQuery ships only with the main app layout)
if (typeof $ !== 'undefined') {
  $('button[data-action="nested-form#add"]').on('click', function() {
    // Wait for the new form to be added to the DOM
    setTimeout(function() {
      // Re-initialize Materialize select fields
      initializeSelects();
    }, 40);
  });
}

document.addEventListener('nested-form:added', () => {
  if (!window.materializeLoaded) return;
  window.materializeLoaded.then((M) => {
    if (!M) return;
    setTimeout(initializeSelects, 0);
  });
});

// Show/Hide password toggle
document.addEventListener('turbo:load', function() {
  handleShowHidePassword();
  let password = document.getElementById('password');
  let confirmPassword = document.getElementById('confirm_password');
  
  if (password) {
      password.addEventListener('focusout', function() {
          if (confirmPassword && password.value !== confirmPassword.value) {
              confirmPassword.classList.remove('valid');
              confirmPassword.classList.add('invalid');
          } else if (confirmPassword) {
              confirmPassword.classList.remove('invalid');
              confirmPassword.classList.add('valid');
          }
      });
  }
  
  if (confirmPassword) {
    confirmPassword.addEventListener('keyup', function () {
      if (password && password.value !== confirmPassword.value) {
        confirmPassword.classList.remove('valid');
        confirmPassword.classList.add('invalid');
      } else {
        confirmPassword.classList.remove('invalid');
        confirmPassword.classList.add('valid');
      }
    });
  }
});

// Floating action button (responsive behavior)
document.addEventListener("turbo:load", function () {
  if (!M) return;

  let isMobileOrTablet = window.innerWidth <= 768;
  M.FloatingActionButton.init(document.querySelectorAll('.fixed-action-btn'), {
    hoverEnabled: !isMobileOrTablet,
    direction: 'top'
  });
});

// Click-based triggers
document.addEventListener('click', function(event) {
  if (event.target.closest('.sidenav-trigger')) {
    event.preventDefault();
    openSidenav(event.target.closest('.sidenav-trigger').dataset.target);
  }
  if (event.target.closest('.modal-trig')) {
    event.preventDefault();
    openModal(event.target.closest('.modal-trig').dataset.modalId);
  }
});

function handleShowHidePassword() {
  document.querySelectorAll('.show-hide-icon').forEach(element => {
    element.addEventListener('click', function() {
      let passwordField = element.previousElementSibling;
      let passwordFieldType = passwordField.getAttribute('type');

      if (passwordFieldType === 'password') {
        passwordField.setAttribute('type', 'text');
        element.textContent = 'visibility_off';
      } else {
        passwordField.setAttribute('type', 'password');
        element.textContent = 'visibility';
      }
    });
  });
}

function openModal(modalId) {
  let modalElement = document.getElementById(modalId);
  if (!modalElement) return;

  let modalInstance = M.Modal.getInstance(modalElement);
  if (!modalInstance) {
    modalInstance = M.Modal.init(modalElement);
  }

  // Open the modal
  modalInstance.open();
}

function openSidenav(sidenavId) {
  let sidenavElement = document.getElementById(sidenavId);
  if (!sidenavElement) return;

  // Initialize the sidenav if not already initialized
  if (!M.Sidenav.getInstance(sidenavElement)) {
    M.Sidenav.init(sidenavElement);
  }

  // Open the sidenav
  let sidenavInstance = M.Sidenav.getInstance(sidenavElement);
  sidenavInstance.open();

  // Add an event listener for the close event
  sidenavElement.addEventListener('sidenav:close', function() {
    document.body.classList.remove('sidenav-open');
  });
}
